import { IClauseList } from "@/api";
import { formatDate } from "@/utils";
import { Box, Stack, Typography } from "@mui/material";

interface IProps {
    /**
     * The clause to display version history for
     */
    clause: IClauseList;
}

/**
 * Displays the version history of a clause
 */
export const VersionHistory = ({ clause }: IProps) => {
    const formattedDate = formatDate(clause.created_at, "PP");

    return (
        <Stack gap={1}>
            <Typography fontWeight={500} gutterBottom>
                Version History
            </Typography>
            <Stack direction="row" gap={2} alignItems="start">
                <Box
                    sx={{
                        mt: 0.5,
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor: "grey.400",
                    }}
                />
                <Stack>
                    <Typography variant="body2" component="span">
                        <Typography
                            variant="body2"
                            fontWeight={500}
                            component="span"
                        >
                            Version 1.0
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            component="span"
                            sx={{ mx: 0.5 }}
                        >
                            •
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            component="span"
                        >
                            {formattedDate}
                        </Typography>
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        First created
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};
